// @flow
import * as React from 'react'
import type {
  PropsSchema,
  EasyAction,
  EventSourceMap,
  JsEnv
} from '../../../type'
import computeData from '../../hoc/computeData'
import styles from './PoundEgg.scss'

type Props = {
  customProps: {
    $comp: {
      eggConfig?: {
        backgroundImage?: {
          url: string
        },
        defaultImage?: {
          url: string
        },
        turnImage?: {
          url: string
        }
      }
    }
  },
  jsEnv: JsEnv,
  children: React.ChildrenArray<React.Node>,
  events: EventSourceMap,
  visible: boolean,
  callActions: (actionName: string, dynamicData: any) => {},
  backgroundImage: ?{
    url: string
  },
  defaultImage: ?{
    url: string
  },
  turnImage: ?{
    url: string
  },
  defaultImageNoChanceUrl: string
};

type State = {
  isStop: boolean
};

@computeData({ includeData: true })
export default class extends React.PureComponent<Props, State> {
  static schema: PropsSchema = [
    {
      type: 'image',
      key: 'backgroundImage',
      title: '背景图片'
    },
    {
      type: 'image',
      key: 'defaultImage',
      title: '原始蛋图片'
    },
    {
      type: 'image',
      key: 'turnImage',
      title: '碎蛋图片'
    },
    {
      type: 'text',
      key: 'defaultImageNoChanceUrl',
      title: '抽奖次数为0碎蛋背景地址'
    },
    'separator',
    {
      type: 'event',
      event: 'stop',
      title: '停止'
    }
  ];
  static actions: EasyAction[] = [
    {
      title: '开始',
      name: 'begin'
    },
    {
      title: '初始化蛋',
      name: 'init'
    }
  ];
  constructor (props: Props) {
    super(props)
    this.state = {
      isStop: false
    }
  }

  componentWillUnmount () {}

  actionBegin = () => {
    let { isStop } = this.state
    if (isStop) {
      return
    }
    setTimeout(() => {
      this.setState(
        {
          isStop: true
        },
        () => {
          this.props.callActions('stop')
        }
      )
    }, 1000)
  };

  actionInit = () => {
    this.setState({
      isStop: false
    })
  };

  render () {
    let {
      customProps = {},
      jsEnv,
      children,
      visible,
      backgroundImage,
      defaultImage,
      turnImage,
      defaultImageNoChanceUrl
    } = this.props
    let { isStop } = this.state
    let eggConfig =
      customProps.$comp && customProps.$comp.eggConfig
        ? customProps.$comp.eggConfig
        : {}
    defaultImageNoChanceUrl = jsEnv.getString(defaultImageNoChanceUrl)
    backgroundImage = backgroundImage || eggConfig.backgroundImage || {}
    defaultImage = defaultImage || eggConfig.defaultImage || {}
    turnImage = turnImage || eggConfig.turnImage || {}
    let backgroundImageUrl = jsEnv.getString(backgroundImage.url || '')
    let defaultImageUrl =
      defaultImageNoChanceUrl || jsEnv.getString(defaultImage.url || '')
    let turnImageUrl = jsEnv.getString(turnImage.url || '')
    if (!visible) {
      return null
    }
    return (
      <div
        className={`${styles.this}`}
        style={{
          backgroundImage: `url(${backgroundImageUrl})`
        }}
      >
        <div style={{ position: 'relative' }}>
          {!isStop && (
            <img
              src={defaultImageUrl}
              className={`${styles.initEgg}`}
              style={defaultImageNoChanceUrl ? { animation: 'none' } : {}}
            />
          )}
          {isStop && (
            <img src={turnImageUrl} className={`${styles.brokenEgg}`} />
          )}
        </div>
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/ui/Draw/PoundEgg.js